import * as React from 'react';
import {Link as RoutedLink} from 'react-router-dom';

import {TableWrapper} from 'shells/dashboard/table/table-wrapper';
import type {Audience} from 'shells/dashboard/types';
// @ts-expect-error - imported from .js/.jsx file
import {SortDownIcon} from 'shells/icon/svg/sort-down-icon';
import {Link} from 'shells/link/link';

type Props = {
    tableData: any[];
};

export const AudiencesTable = (props: Props) => {
    const columns = React.useMemo(
        () => [
            {
                id: 'name',
                Header: 'Name',
                accessor: (row: Audience) => row,
                dataType: 'linkedName',
                width: 200,
                shouldTruncate: true,
                titleKey: 'name',
            },
            {
                id: 'subscribers',
                Header: (
                    <div className='flex align-center gap-8'>
                        <SortDownIcon size={14} alignCenter={true} />
                        Subscribers
                    </div>
                ),
                accessor: (row: Audience) => row.total,
                dataType: 'integer',
                width: 120,
                minWidth: 120,
            },
        ],
        []
    );

    return (
        <TableWrapper
            columns={columns}
            items={props.tableData}
            isLoading={false}
            error={null}
            emptyStateProps={{
                title: 'An audience has not been created yet',
                subtitle: 'Audiences with the most subscribers will be listed here',
                cta: (
                    <Link
                        // @ts-expect-error
                        as={RoutedLink}
                        variant='button'
                        size='big'
                        to='/email-marketing/audiences'
                    >
                        Create new audience
                    </Link>
                ),
            }}
        />
    );
};
